var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 42,
    viewBox: "0 0 233 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_591_10588)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 232.333,
    height: 41.0476,
    rx: 10,
    fill: "black",
    fillOpacity: 0.09
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 231.333,
    height: 40.0476,
    rx: 9.5,
    stroke: "white",
    strokeOpacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5238,
    cy: 20.5238,
    r: 12.5238,
    fill: "#0C0C83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9575 21.177L26.5666 23.7861L33.0895 17.2633",
    stroke: "white",
    strokeWidth: 1.56548,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.0479,
    y: 19.7411,
    width: 62.619,
    height: 1.56548,
    fill: "#0C0C83"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.19,
    cy: 20.5238,
    r: 11.7411,
    stroke: "#0C0C83",
    strokeWidth: 1.56548
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.191,
    cy: 20.5238,
    r: 3.91369,
    fill: "#0C0C83"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.714,
    y: 19.7411,
    width: 62.619,
    height: 1.56548,
    fill: "#D1D5DB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.857,
    cy: 20.5238,
    r: 11.7411,
    stroke: "#D1D5DB",
    strokeWidth: 1.56548
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_591_10588",
    x: -104,
    y: -104,
    width: 440.333,
    height: 249.048,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 52
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_591_10588"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_591_10588",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepTwo);
export default __webpack_public_path__ + "static/media/step-two.4687aea5ef93e97403712a41741c9729.svg";
export { ForwardRef as ReactComponent };